$.ajaxSetup({
	timeout:8000,
	error: function(jqXHR, exception) {
		if (jqXHR.status === 0) {
		} else if (jqXHR.status == 403) {
			url = "403.html";
			//window.location.href = url;
		} else if (jqXHR.status == 404) {
			url = "/users/error/";
			//window.location.href = url;
		} else if (jqXHR.status == 503) {
			url = "/users/error/";
			location.assign(url);
		} else if(jqXHR.status == 401){
		}else if(jqXHR.status == 408){
		}else if(jqXHR.status == 409){
		}else if(jqXHR.status == 200){
			console.log(jqXHR);
		}else if(jqXHR.status == 201){
			console.log(jqXHR);
		}else if(jqXHR.status == 307){
			console.log(jqXHR);
		}else if (exception === 'parsererror') {
			//alert('Requested JSON parse failed.');
		} else if (exception === 'timeout') {
			//alert('Time out error.');
			//$('.feedback').text('Error. Please try again later.');
		} else if (exception === 'abort') {
			//alert('Ajax request aborted.');
			//$('.feedback').text('Error. Please try again later.');
		} else {
			console.log('Uncaught Error.\n' + jqXHR.responseText);
		}
	},
	complete:function(XMLHttpRequest, textStatus){

	}

	/*
	Cross-Domain
	,
	xhrFields: {
		withCredentials: true
	}*/
});
var AjaxControl = {
	cargarAjax:function(tipo, URL, filtros, cabecera){
		$.support.cors = true;
		return $.ajax({
			contentType: 'application/json;charset=UTF-8',
			mimeType: 'application/json',
			crossDomain: true,
			type:tipo,
			dataType:"json",
			data:filtros,
			global: false,
			url: URL
		});
	},
	cargarAjaxCD:function(tipo,URL, filtros, cabecera){
		$.support.cors = true;
		var bearer;
		if(Cookies.get('hub')!== undefined){
			bearer = 'Bearer ' + Cookies.get('hub').replace(/Bearer\+/g,'');
		}
		return $.ajax({
			crossDomain:true,
			dataType:'json',
			xhrFields:{withCredentials: true},
			type:tipo,
			data:filtros,
			global: false,
			url: URL,
		  headers: {
		    Authorization: bearer
		  }
		});
	},
	cargarToken:function(tipo, URL, filtros, token){
		$.support.cors = true;
		return $.ajax({
			crossDomain:true,
			dataType:'json',
			xhrFields:{withCredentials: true},
			type:tipo,
			data:filtros,
			global: false,
			url: URL + '?access_token='+Cookies.get('token')
		});
	},
	cargarAjaxToken:function(tipo, URL, filtros, token){
		$.support.cors = true;
		return $.ajax({
			crossDomain:true,
			xhrFields:{withCredentials: true},
			contentType: 'application/json;charset=UTF-8',
			dataType:'json',
			type:tipo,
			data:filtros,
			global: false,
			url: URL,
		  headers: {
		    Authorization: 'Bearer ' + Cookies.get('hub').replace(/Bearer\+/g,'')
		  }
		});
	},
	cargarAjaxNoToken:function(tipo, URL, filtros, token){
		$.support.cors = true;
		return $.ajax({
			crossDomain:true,
			contentType: 'application/json;charset=UTF-8',
			dataType:'json',
			type:tipo,
			data:filtros,
			global: false,
			url: URL,
			xhrFields: {
			    withCredentials: true
			}
		});
	},
	cargarNL:function(tipo,URL, filtros){
		$.support.cors = true;
		return $.ajax({
			contentType:  'application/x-www-form-urlencoded',
			crossDomain: true,
			type:tipo,
			dataType:"application/x-www-form-urlencoded",
			data:filtros,
			global: false,
			url: URL + '?access_token='+Cookies.get('token')
		});
	},
	cargarAdjuntos:function(tipo,URL,filtros,content,process){
		$.support.cors = true;
		if(typeof(content)==='undefined') content = "application/json";
		if(typeof(process)==='undefined') process = true;
		return $.ajax({
			contentType: content,
			//mimeType: 'application/json',
			processData: process,
			cache:false,
			crossDomain: true,
			xhr: function(){
				var xhr = new window.XMLHttpRequest();
				//Upload progress
				xhr.upload.addEventListener("progress", function(evt){
					if (evt.lengthComputable) {
						$(".tapa_preload_adjunto").removeClass("oculto");
						var percentComplete = evt.loaded / evt.total;
						$(".tapa_preload_adjunto .progress-bar").attr("style","width:"+(percentComplete*100)+"%");
					}
				}, false);
				//Download progress
				xhr.addEventListener("progress", function(evt){
					if (evt.lengthComputable) {
						var percentComplete = evt.loaded / evt.total;
						//Do something with download progress
						if(percentComplete == 1) {
							$(".tapa_preload_adjunto").addClass("oculto");
						}
					}
				}, false);
				return xhr;
			},
			type:tipo,
			dataType:"json",
			data:filtros,
			global: false,
			url: URL
		});
	}
};
